import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Grid from '../../components/Grid';

import TravelPlanResult from './repvisits-travel-plan-result';

import './styles.css';

const RepVisitsTravelPlanResults = ({ travelPlan, displayNotification, showSideBar, viewer, removeTravelPlan }) => (
  <Grid stackable width={16} styleName="results-container-row">
    <Grid.Row styleName="result-header-container">
      <Grid.Column width={16}>
        <h2 styleName="result-header">
          {travelPlan.state} {get(travelPlan, 'institutions.length')}
        </h2>
      </Grid.Column>
    </Grid.Row>
    {get(travelPlan, 'institutions.length') && (
      travelPlan.institutions.map((institution, index) => (
        <TravelPlanResult
          key={institution.id}
          institution={institution}
          displayNotification={displayNotification}
          showSideBar={showSideBar}
          isLastStateInstitution={get(travelPlan, 'institutions.length') === (index + 1)}
          viewer={viewer}
          removeTravelPlan={removeTravelPlan}
        />
      )))}
  </Grid>
);
RepVisitsTravelPlanResults.propTypes = {
  travelPlan: PropTypes.object.isRequired,
  displayNotification: PropTypes.func.isRequired,
  showSideBar: PropTypes.func.isRequired,
  viewer: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  removeTravelPlan: PropTypes.func.isRequired,
};

export default RepVisitsTravelPlanResults;
